import React from 'react';
import { AxiosError } from 'axios';

import {
  IAlertDialogProps,
  alertDialogPropsInitial,
} from '../../shared/components/AlertDialog';
import { PageLocation } from '../../shared/enum/PageLocation';
import { IDashboard } from '../../Services/DashboardService';

export interface IHomeContextProps {
  spreadsheetId: number | null;
  setSpreadsheetId: (spreadSheetId: number) => void;
  pageLocation: PageLocation;
  setPageLocation: (pageLocation: PageLocation) => void;
  openLoadingDialog: boolean;
  setOpenLoadingDialog: (open: boolean) => void;
  alertProps: IAlertDialogProps;
  setAlertProps: (props: IAlertDialogProps) => void;
  showError: (message: string, error?: AxiosError) => void;
  showWarning: (message: string) => void;
  showSuccess: (message: string) => void;
  influencerClientEnable: {
    id: number;
    id_cliente: number;
    nome: string;
  } | null;
  setInfluencerClientEnable: (influencerClientEnable: {
    id: number;
    id_cliente: number;
    nome: string;
  }) => void;
  influencerListClientEnable: {
    id: number | null;
    id_cliente: number | null;
    nome: string;
  };
  setInfluencerListClientEnable: (influencerClientEnable: {
    id: number;
    id_cliente: number;
    nome: string;
  }) => void;
  selectedDashboard: IDashboard | null;
  setSelectedDashboard: (dashboard: IDashboard | null) => void;
}

export const homeContextInitial: IHomeContextProps = {
  spreadsheetId: null,
  setSpreadsheetId: () => {
    ('');
  },
  pageLocation: PageLocation.HISTORY,
  setPageLocation: () => {
    ('');
  },
  openLoadingDialog: false,
  setOpenLoadingDialog: () => {
    ('');
  },
  alertProps: alertDialogPropsInitial,
  setAlertProps: () => {
    ('');
  },
  showError: () => {
    ('');
  },
  showWarning: () => {
    ('');
  },
  showSuccess: () => {
    ('');
  },
  influencerClientEnable: null,
  setInfluencerClientEnable: () => {
    ('');
  },
  influencerListClientEnable: { id: null, id_cliente: null, nome: '' },
  setInfluencerListClientEnable: () => {
    ('');
  },
  selectedDashboard: null,
  setSelectedDashboard: () => {
    ('');
  },
};

export const HomeContext = React.createContext(homeContextInitial);
